const MAX_ACKNOWLEDGEMENTS = 500
const acknowledgedRevisions = new Map<string, number>()

export function locallyAcknowledgedPreviewRevision(conversationId: string): number {
  return acknowledgedRevisions.get(conversationId) ?? 0
}

export function rememberPreviewAcknowledgement(conversationId: string, revision: number): void {
  const current = locallyAcknowledgedPreviewRevision(conversationId)
  if (revision <= current) {
    return
  }
  acknowledgedRevisions.delete(conversationId)
  acknowledgedRevisions.set(conversationId, revision)
  if (acknowledgedRevisions.size > MAX_ACKNOWLEDGEMENTS) {
    acknowledgedRevisions.delete(acknowledgedRevisions.keys().next().value as string)
  }
}

export function forgetPreviewAcknowledgement(conversationId: string, revision: number): boolean {
  if (acknowledgedRevisions.get(conversationId) === revision) {
    acknowledgedRevisions.delete(conversationId)
    return true
  }
  return false
}

/**
 * A conversation is unread while its latest preview revision is ahead of the acknowledged one.
 * The local acknowledgement wins over the server's value so a row clears the moment it is opened,
 * without waiting for a refetch.
 */
export function isPreviewRevisionUnread(
  conversationId: string,
  previewRevision: number,
  acknowledgedRevision: number | undefined,
): boolean {
  return previewRevision > Math.max(acknowledgedRevision ?? 0, locallyAcknowledgedPreviewRevision(conversationId))
}
